<script>
  import axios from "axios";
  import qs from "qs";
  import { onMount } from "svelte";
  import Button from "@smui/button";
  import Checkbox from "@smui/checkbox";
  import List, { Item, Text } from "@smui/list";
  import Textfield from "@smui/textfield";
  import { Icon as CommonIcon } from "@smui/common";
  import Paper, { Title, Subtitle, Content } from "@smui/paper";
  import FormField from "@smui/form-field";
  import { Stretch } from "svelte-loading-spinners";
  import IconButton from '@smui/icon-button';

  const axiosAPI = axios.create({
    baseURL: "https://api.podlodka.io/billingator",
    // baseURL: "http://localhost:3000",
    // baseURL: "https://stoplight.io/mocks/podlodka/billingator/9903012",
    // baseURL: "https://gentle-lowlands-77779.herokuapp.com",
  });

  // loading state
  let submitLoading = false;

  let email = "";
  let firstname = "";
  let lastname = "";
  let numberOfVisitsForCertificate = [1];

  let isUnderMaintenance;

  $: isSubmitButtonEnabled = !isFormInvalid && !submitLoading;
  $: isFormInvalid =
  numberOfVisitsForCertificate.length == 0 ||
    !email ||
    !firstname ||
    !lastname ||
    !policyChecked;

  let initialPrice;
  let discountPrice;
  let policyChecked = false;

  let fetchMaintancePromise;

  $: if (numberOfVisitsForCertificate) {
    fetchPrice();
  }

  onMount(async () => {
    fetchMaintancePromise = checkMaintenanceStatus();
    isUnderMaintenance = await fetchMaintancePromise;
  });

  async function checkMaintenanceStatus() {
    let result = await axiosAPI.get("/maintenance");
    return result.data["under_maintenance"];
  }

  async function fetchPrice() {
    if (numberOfVisitsForCertificate.length == 0) {
      initialPrice = undefined;
      discountPrice = undefined;
      return;
    }

    try {
      const result = await axiosAPI.get("/price", {
        params: {
          offer_ids: numberOfVisitsForCertificate.map(
            (element) => "rover_" + element
          ),
          // promo: promocode,
        },
        paramsSerializer: function (params) {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      let json = await result;
      if (json.data.discount_price !== undefined) {
        initialPrice = json.data.initial_price;
        discountPrice = json.data.discount_price;
      } else if (json.data.Error) {
        alert(json.data.Error);
      }
    } catch (error) {
      alert(error);
    }
  }

  const addCert = () => {
    numberOfVisitsForCertificate = [...numberOfVisitsForCertificate, 1];
  };

  const removeCert = (i) => {
    numberOfVisitsForCertificate.splice(i, 1);
    numberOfVisitsForCertificate = [...numberOfVisitsForCertificate];
  };

  const upgradeCert = (i) => {
    numberOfVisitsForCertificate[i] += 1;
    numberOfVisitsForCertificate = [...numberOfVisitsForCertificate];
  };

  const degradeCert = (i) => {
    numberOfVisitsForCertificate[i] -= 1;
    numberOfVisitsForCertificate = [...numberOfVisitsForCertificate];
  };

  const submitForm = async () => {
    if (numberOfVisitsForCertificate.length == 0) {
      alert("Положите в корзину хотя бы один универсальный билет");
      return;
    }

    if (!policyChecked) {
      alert(
        "Для продолжения необходимо принять условия лицензионного соглашения"
      );
      return;
    }

    trackEvent("roverPurchase", discountPrice);

    try {
      submitLoading = true;
      const result = await axiosAPI.post("/buy_rover", createPaymentFormData());
      submitLoading = false;

      if (result.data.confirmation_url) {
        window.location.assign(result.data.confirmation_url);
        return;
      } else if (result.data.confirmation_status == "free") {
        alert("Спасибо за покупку! ;)");
        return;
      } else if (result.data.Error) {
        alert(result.data.Error);
        return;
      } else {
        alert("Что-то пошло не так. Успешный ответ, но нет confirmation_url");
        return;
      }
    } catch (error) {
      submitLoading = false;
      alert(error);
    }
  };

  function createPaymentFormData() {
    var formData = {};

    formData["customer_email"] = email;
    formData["customer_name"] = firstname;
    formData["customer_surname"] = lastname;

    var orders = [];
    numberOfVisitsForCertificate.forEach((numberOfVisits) => {
      var order = {
        offer_id: "rover_" + numberOfVisits,
      };
      orders.push(order);
    });
    formData["orders"] = orders;
    return formData;
  }

  function trackEvent(event, value) {
    if (typeof gtag !== "undefined") {
      var payload = {
        event_category: "payment_platform",
        event_label: "rovers",
        value: value,
      };

      gtag("event", event, payload);
    }

    if (typeof fbq !== "undefined") {
      var payload = {
        content_category: "payment_platform",
        content_name: "playlists",
      };

      if (value) {
        payload["value"] = value;
        payload["currency"] = "RUB";
      }

      fbq("trackCustom", event, payload);
    }
  }
</script>

<main>
  <div class="box">
    <div class="paper-container">
      <Paper elevation={1} class="paper-demo">
        <div class="title">
          <Title>Корзина</Title>
          <div class="subtitle">
            <Subtitle>На почту придет два письма на каждый универсальный билет: с подтверждением покупки и красивое письмо-билет, которое можно переслать в качестве подарка</Subtitle>
          </div>
        </div>
        {#await fetchMaintancePromise}
          <div class="loader">
            <Stretch size="100" unit="px" />
          </div>
        {:then}
          {#if isUnderMaintenance}
            <p>Прямо сейчас мы шатаем форму на бою 😱</p>
          {:else}
              <div class="certTable">
                <List nonInteractive>
                  {#each numberOfVisitsForCertificate as offerId, i}
                    <Item style="height: fit-content; padding: 10px 0px;">
                      <Text>
                        Универсальный билет
                      </Text>
                      <div class="certControlPanel">
                        <IconButton class="material-icons" on:click={() => degradeCert(i)} ripple={false} disabled={offerId <= 1}
                          >remove</IconButton
                        >
                        <span class="certCounterNumber">{offerId}</span>
                        <IconButton class="material-icons" on:click={() => upgradeCert(i)} ripple={false} disabled={offerId >= 9}
                          >add</IconButton
                        >

                        <IconButton class="material-icons" on:click={() => removeCert(i)} ripple={false}
                          >delete</IconButton
                        >
                      </div>
                    </Item>
                  {/each}
                </List>
                <Button on:click={addCert} style="padding: 0px">
                  Добавить билет
                </Button>
              </div>
              <hr>
              <br>
              {#await fetchPrice}
                <div class="loader">
                  <Stretch size="100" unit="px" />
                </div>
              {:then}
                {#if discountPrice == 0 || discountPrice == null}
                  <h3 style="margin: 0px 15px 0px">Бесплатно</h3>
                {:else}
                    <h3 style="margin: 0px 15px 0px">
                      {#if discountPrice != initialPrice}
                        <s>{initialPrice}₽</s>
                      {/if}
                      {discountPrice}₽
                    </h3>
                {/if}
              {/await}
          {/if}
        {:catch error}
          <p style="color: red">{error.message}</p>
          <p>
            Что-то пошло не так. Напишите в
            <a href="https://t.me/podlodkacrew_support">чат саппорта</a>
          </p>
        {/await}
      </Paper>
    </div>

    {#await fetchMaintancePromise then isUnderMaintenance}
      {#if !isUnderMaintenance}
        <div class="paper-container">
          <Paper elevation={1} class="paper-demo">
            <div class="title">
              <Title>Данные</Title>
              <Subtitle>Покупка придет на указанную почту</Subtitle>
            </div>
            <div class="personal_input">
              <Textfield
                style="width: 90%"
                variant="outlined"
                bind:value={lastname}
                label="Фамилия"
                input$autocomplete="family_name"
                required
              />
            </div>
            <div class="personal_input">
              <Textfield
                id="input-firstname"
                style="width: 90%"
                variant="outlined"
                bind:value={firstname}
                input$autocomplete="first_name"
                label="Имя"
                required
              />
            </div>
            <div class="personal_input">
              <Textfield
                style="width: 90%"
                variant="outlined"
                bind:value={email}
                input$autocomplete="email"
                label=""
                type="email"
                required
              >
                <span slot="label"
                  >
                  <!-- <CommonIcon
                    class="material-icons"
                    style="font-size: 1em; line-height: normal; vertical-align: middle;"
                  >
                    email
                  </CommonIcon> -->
                  Email</span
                >
              </Textfield>
            </div>
            <div class="license">
              <FormField required>
                <Checkbox bind:checked={policyChecked} />
                <span slot="label"
                  >Я подтверждаю свое согласие с условиями
                  <a href="https://podlodka.io/crew-legal"
                    >Пользовательского соглашения</a
                  >
                  и
                  <a href="https://podlodka.io/data-processing"
                    >Обработки персональных данных</a
                  ></span
                >
              </FormField>
            </div>
            <Button
              style="margin: 0px 10px;"
              class="submit"
              variant="unelevated"
              on:click={submitForm}
              disabled={!isSubmitButtonEnabled}
            >
              Беру!
            </Button>
            {#if submitLoading}
              <div style="margin: 0px 10px;">
                <Stretch size="50" unit="px" />
              </div>
            {/if}
          </Paper>
        </div>
      {/if}
    {/await}
  </div>
</main>

<style>
  main {
    background-color: #f8f8f8;
    min-width: 450px;
  }
  .subtitle {
    color: rgba(0, 0, 0, 0.66);
  }

  .certControlPanel {
    display: block;
    justify-content: space-between;
    align-items: center;
    margin-left: auto;
    margin-right: 0;
  }
  .certTable {
    margin: 0px 10px;
  }
  .certCounterNumber {
    font-size: 27px;
  }
  .title {
    margin: 0px 10px;
  }
  .paper-container {
    padding: 9px 18px;
    max-width: 45em;
    margin-left: auto;
    margin-right: auto;
  }

  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 256px;
  }

  .box {
    padding: 100px 0;
    max-height: 80vh;
    overflow: auto;
  }

  .promocode_input {
    margin-right: 10px;
  }

  .personal_input {
    width: 55%;
    margin: 10px;
  }

  .license {
    margin-bottom: 10px;
  }

  .cart-box {
    border-width: 1px;
    border-radius: 8px;
    border-style: solid;
    border-color: rgb(158, 158, 158);
    margin: 20px 10px;
    padding: 4px;
  }

  .card-list {
    margin-top: 0px;
    padding-inline-start: 15px;
    padding-inline-end: 15px;
  }

  .card-list-item {
    position: relative;
    overflow: auto;
  }

  * :global(.fatButton) {
    height: 50px;
    margin-bottom: 0px;
  }

  @media (max-width: 500px) {
    .promocode_input {
      width: 100%;
      margin-bottom: 10px;
    }
    .personal_input {
      width: 100%;
    }
  }
</style>
